/**
 * anonymousZapperModal.tsx
 */
import AppLogo from '../../atoms/images/modalLogo';
import ChannelUp from '../../elements/images/channelUp';
import ChannelDown from '../../elements/images/channelDown';
import ChannelLogo from '../../atoms/images/centerChannelLogo';
import Container from '../../atoms/container/modalContainer';
import Buttons from '../../elements/modal/anonymousModalButtons';
import Description from '../../elements/modal/anonymousModalDescription';
import FlavourConfig from '@shared/config/flavours';
import Icons from '../../elements/modal/anonymousModalUpgrades';
import Subtitle from '../../atoms/text/modalSubtitle';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { channelDown, channelUp } from '@shared/store/thunks/channels.thunk';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { popRoute } from '@shared/store/thunks/route.thunk';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';

/**
 * Displays the anonymous zapper modal.
 */
export default function AnonymousZapperModal() {
  const dispatch = useAppDispatch();
  const { currentChannel } = useAppSelector(channelsSelector);

  useKeyboard({
    keyDownHandler: (key) => {
      switch (key) {
        case 'UP':
        case 'CHANNEL_UP':
          dispatch(channelUp());
          break;
        case 'DOWN':
        case 'CHANNEL_DOWN':
          dispatch(channelDown());
          break;
        case 'BACK':
          dispatch(popRoute());
          break;
      }
    },
    canBeFocused: false,
    stopPropagation: true,
  });

  return (
    <Container>
      <AppLogo />
      <Description />
      <Title>
        {TranslationManager.get(
          'MODAL.ANONYMOUS.TITLE',
          FlavourConfig.appTitle
        )}
      </Title>
      <Subtitle>{TranslationManager.get('MODAL.ANONYMOUS.SUBTITLE')}</Subtitle>
      <Icons />
      <Buttons allowZapping={true} />
      <ChannelUp />
      <ChannelDown />
      <ChannelLogo src={currentChannel?.logo} style={{ opacity: '0.1' }} />
    </Container>
  );
}
